<template>
  <v-card>
    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout class="unitAlertsHeader" row>
        <v-flex>
          <span class="unitAlertName">ALERTS FOR CLIENTS IN UNIT {{ unit.name }}</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="height: calc(90vh - 96px);">
      <v-data-table style="height: 100%;" :headers="headers" :items="unitAlertCodes" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr style="height:24px !important;">
            <td>{{ props.item.alertName }}</td>
            <td>{{ props.item.roomName }}</td>
            <td>{{ props.item.clientFirstName }}</td>
            <td>{{ props.item.clientLastName }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions />
  </v-card>
</template>


<script lang="js">
export default {
  name: 'UnitAlertsCard',
  data() {
    return {
      headers: [
        {
          text: 'Alert',
          align: 'left',
          sortable: true,
          value: 'alertName'
        },
        { text: 'Room', value: 'roomName' },
        { text: 'First Name', value: 'clientFirstName' },
        { text: 'Last Name', value: 'clientLastName' }
      ]
    };
  },
  props: {
    onClose: Function,
    unit: Object
  },
  components: {
  },
  computed: {
    unitAlertCodes() {
      return this.$store.getters.getUnitAlertCodes(this.unit.bedBoardUnitID.id);
    }
  },
  methods: {
    close() {
      this.onClose();
    },
  }
};
</script>


<style lang="scss">
table.v-table tbody td {
  height: 24px;
}
table.v-table thead tr {
  height: 32px;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.unitAlertName {
  color: #39b54a;
  font-size: 14px;
  font-weight: 700;
}
.v-table__overflow {
  height: 100%;
  overflow-y: auto;
}
</style>
